import React from 'react';

import Quorum from '../../components/admin/Quorum';
import PageLayout from '../../components/layout/PageLayout';

const AdminMeetingPage = () => {
  return (
    <PageLayout>
      <Quorum />
    </PageLayout>
  );
};

export default AdminMeetingPage;
